import type { CSSProperties } from 'react';
import { buildDividerStyles } from './divider-styles';

/**
 * One `<hr>` — nothing else.
 *
 * The element is the whole accessibility story. `<hr>` carries the implicit
 * `separator` role, so a screen reader announces the break between sections
 * without an ARIA attribute anywhere, and a search engine reads the same
 * structure. A styled `<div>` would look identical and say nothing.
 *
 * Appearance is the component's own defaults with column styles on top: the
 * divider's styles are spread first so anything the author set in Column
 * Styles lands later in the object and wins.
 *
 * Nothing here needs the browser. There is no state, no measurement and no
 * resolution after hydration — the line is complete in the server's HTML.
 */
export function RDivider({
  componentAttributes,
  styleProps,
  className,
}: Readonly<{
  componentAttributes?: { [key: string]: any };
  /** Column styles from the widget pipeline. Always applied to the rule itself. */
  styleProps?: { [key: string]: any };
  /** Host-app classes for this column. The single root element carries them. */
  className?: string;
}>) {
  const style: CSSProperties = {
    ...buildDividerStyles(componentAttributes),
    ...styleProps,
  };

  return <hr style={style} {...(className !== undefined ? { className } : {})} />;
}
